import first from './images/student1.jpg'
import second from './images/student2.jpeg'
import third from "./images/student3.jpg"
const people = [
  {
    id: 1,
    image: first,
    name: "Dr. Shibu Hussain",
    title: "Govt. Collage , Lucknow",
    quote:
      "Dr. Majid changed my life. He allowed me to fall in love with biology as a subject. Their innovative Story Mode Method of Teaching is something i had never experienced before",
  },
  {
    id: 2,
    image: second,
    name: "Dr. Parikshit Kumar Likhi",
    title: "AIIMS Mumbai, NEET Score 665",
    quote:
      "Teachers at Dr. Khan Online Classes are extremely dedicated to making it a point for every student to be equally interactive in Online sessions. Content is both fun and educational which makes it ideal for both NEET and school level. ",
  },
  {
    id: 3,
    image: third,
    name: "Mohammad Bilal",
    title: "Queen Mary University of London M. Tech. Biomedical & Prosthetics",
    quote:
      "I had a mathematics background but Dr. Khan helped me grasp concepts I wasn't previously familiar with. He helped me link the two and see biology from a completely new prespective.",
  },
];

export default people;
